"use strict";
exports.__esModule = true;
var filterAvailableClasses = function (classes) {
    return !!classes && Object.keys(classes).filter(function (classKey) { return !!classes[classKey]; }).map(function (key) { return "" + key; }).join(' ');
};
var buildClassNames = function (className, optionalClasses) {
    var baseClassName = typeof className === 'string' ? className : filterAvailableClasses(className);
    var filteredOptionalClasses = filterAvailableClasses(optionalClasses);
    var parsedClassName = !!filteredOptionalClasses ? baseClassName + " " + filteredOptionalClasses : baseClassName;
    return parsedClassName;
};
exports["default"] = buildClassNames;
